import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder: {
    id: 'components.atom.placeAutcomplete.placeholder',
    defaultMessage: 'Type an address...',
  },
});
